import React, { useEffect, useState } from "react";
import LineRaceChart from "../../CHARTS/LineRaceChart";
import StackedBarVariation2 from "../../CHARTS/StackedBarVariation2";
import StackedBarVariation from "../../CHARTS/StackedBarVariation";
const WorkingHoursGraph = ({ data, selectedFilters }) => {
  // useEffect(() => {
  //   if (data ) {
  //     const monthToSum = [...selectedFilters?.selectedMonth];
  //     const lobbyToSum = [...selectedFilters?.selectedLobby].filter(
  //       (l) => l !== "TOTAL"
  //     );
  //     const tempChartData = monthToSum.map((key) => ({
  //       time: key,
  //       "Month Wise Working Hours": data
  //         .filter((o) => o.cms_month === key)
  //         .reduce((sum, obj) => sum + (Number(obj.wh_total) || 0), 0),
  //     }));

  //     const keyToSum = [
  //       "wh_less_than_equals_4hr",
  //       "wh_4_to_6_hr",
  //       "wh_6_to_8_hr",
  //       "wh_8_to_9_hr",
  //       "wh_9_to10_hr",
  //       "wh_10_to_11_hr",
  //       "wh_11_to_12_hr",
  //       "wh_12_to_14_hr",
  //     ];
  //     const tempHoursWise = keyToSum.map((key) => ({
  //       time: key.replace(/wh_/g, "").replace(/_/g, "\n"),
  //       "Working Hours": data
  //         .filter((o) => o.wh_lobby !== "TOTAL") //
  //         .reduce((sum, obj) => sum + (Number(obj[key]) || 0), 0),
  //     }));
  //     const tempLobbyWise = lobbyToSum.map((key) => ({
  //       time: key,
  //       "Lobby wise Working Hours": data
  //         .filter((o) => o.wh_lobby === key)
  //         .reduce((sum, obj) => sum + (Number(obj.wh_total) || 0), 0),
  //     }));
  //     setChartData({
  //       ...chartData,
  //       hoursWise: tempHoursWise,
  //       monthWise: tempChartData.filter((v) => v !== false),
  //       lobbyWise: tempLobbyWise,
  //     });
  //   }
  // }, [data]);

  return (
    <div className="newUiBody">
      <div className="row">
        {/* <div className="col-md-6">
          <div className="newUiBody">
            <div className=" bg-dark text-white p-1 d-flex">
              <h5> Crew Working Hours Graph</h5>
              <b className="pt-1" style={{ color: "rgba(189, 188, 188, 1)" }}>
                {" "}
                (Month wise)
              </b>
            </div>

            {chartData && (
              <LineRaceChart from={"20ACP"} data={chartData.monthWise} />
            )}
          </div>
        </div>
        <div className="col-md-6 ">
          <div className="newUiBody">
            <div className=" bg-dark text-white p-1 d-flex">
              <h5> Crew Working Hours Graph</h5>
              <b className="pt-1" style={{ color: "rgba(189, 188, 188, 1)" }}>
                {" "}
                (Hours wise)
              </b>
            </div>

            {chartData && (
              <LineRaceChart from={"hours"} data={chartData.hoursWise} />
            )}
          </div>
        </div>
        <div className="col-md-6 ">
          <div className="newUiBody">
            <div className=" bg-dark text-white p-1 d-flex">
              <h5> Crew Working Hours Graph</h5>
              <b className="pt-1" style={{ color: "rgba(189, 188, 188, 1)" }}>
                {" "}
                (Lobby wise)
              </b>
            </div>

            {chartData && (
              <LineRaceChart from={"20ACP"} data={chartData.lobbyWise} />
            )}
          </div>
        </div> */}

        <div className="col-md">
          <div className="">
            <div className=" bg-dark text-white p-1 d-flex">
              <h5> Crew Working Hours Graph</h5>
              <b className="pt-1" style={{ color: "rgba(189, 188, 188, 1)" }}>
                {" "}
                (Lobby wise)
              </b>
            </div>
            {data && <StackedBarVariation from="hours" data={data} />}
          </div>
        </div>
      </div>
    </div>
  );
};
export default WorkingHoursGraph;
